
      body.openclaw-mount-fallback-active {
        margin: 0;
        min-width: 320px;
        color: #eef4f8;
        background: #101418;
        font-family:
          Inter,
          ui-sans-serif,
          system-ui,
          -apple-system,
          BlinkMacSystemFont,
          "Segoe UI",
          sans-serif;
      }

      body.openclaw-mount-fallback-active openclaw-app {
        display: none;
      }

      .mount-fallback {
        box-sizing: border-box;
        /* The app stylesheet clips the root scrollers, so this pre-app error
           surface must own its scrolling on short windows. dvh keeps the
           scroll range inside the visible mobile viewport; vh is the fallback. */
        height: 100vh;
        height: 100dvh;
        overflow-y: auto;
        padding: 24px;
        place-items: center;
        place-items: safe center;
      }

      .mount-fallback:not([hidden]) {
        display: grid;
      }

      .mount-fallback__panel {
        box-sizing: border-box;
        width: min(100%, 640px);
        border: 1px solid rgba(148, 163, 184, 0.28);
        border-radius: 8px;
        background: #151b21;
        box-shadow: 0 24px 80px rgba(0, 0, 0, 0.36);
        padding: 28px;
      }

      .mount-fallback__eyebrow {
        margin: 0 0 10px;
        color: #9fb0bd;
        font-size: 0.78rem;
        font-weight: 700;
        letter-spacing: 0.08em;
        text-transform: uppercase;
      }

      .mount-fallback__panel h1 {
        margin: 0;
        color: inherit;
        font-size: clamp(1.5rem, 3vw, 2rem);
        line-height: 1.15;
      }

      .mount-fallback__panel p {
        margin: 16px 0 0;
        color: #c8d3da;
        font-size: 1rem;
        line-height: 1.6;
      }

      .mount-fallback__panel ul {
        margin: 18px 0 0;
        padding-left: 1.2rem;
        color: #c8d3da;
        line-height: 1.6;
      }

      .mount-fallback__panel a {
        color: #8bd3ff;
        text-decoration-thickness: 0.08em;
        text-underline-offset: 0.18em;
      }

      .mount-fallback__actions {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        margin-top: 24px;
      }

      .mount-fallback__button {
        min-height: 42px;
        border: 1px solid rgba(148, 163, 184, 0.36);
        border-radius: 6px;
        padding: 0 16px;
        color: inherit;
        background: transparent;
        font: inherit;
        font-weight: 700;
      }

      .mount-fallback__button--primary {
        border-color: #66c2ff;
        color: #061019;
        background: #8bd3ff;
      }

      .mount-fallback__panel:focus {
        outline: none;
      }

      .mount-fallback__button:focus-visible,
      .mount-fallback__panel a:focus-visible {
        outline: 3px solid #f9c74f;
        outline-offset: 3px;
      }

      html[data-theme-mode="light"] body.openclaw-mount-fallback-active {
        color: #151b21;
        background: #f5f7fa;
      }

      html[data-theme-mode="light"] .mount-fallback__panel {
        border-color: rgba(71, 85, 105, 0.22);
        background: #ffffff;
        box-shadow: 0 24px 80px rgba(15, 23, 42, 0.14);
      }

      html[data-theme-mode="light"] .mount-fallback__eyebrow,
      html[data-theme-mode="light"] .mount-fallback__panel p,
      html[data-theme-mode="light"] .mount-fallback__panel ul {
        color: #4b5963;
      }

      html[data-theme-mode="light"] .mount-fallback__panel a {
        color: #0369a1;
      }
    